import { defineComponent as K, ref as N, reactive as B, onMounted as E, watch as i, resolveDirective as I, createElementBlock as p, openBlock as c, createCommentVNode as $, createElementVNode as a, renderSlot as l, toDisplayString as S, normalizeClass as d, createVNode as T, withCtx as U, withDirectives as M, withKeys as m, vModelDynamic as R, vShow as z, nextTick as f } from "vue";
import { i as A, b as P } from "./baseMixins-HJffeBsS.js";
import L from "./OverflowTooltip.js";
import { d as O } from "./debounce-BJrVv5jG.js";
const j = { class: "arbo-input" }, q = {
  key: 0,
  class: "arbo-input__label"
}, G = { class: "arbo-input__label--text" }, H = { class: "arbo-input__prepend" }, J = ["min", "max", "placeholder", "disabled", "type", "pattern"], Q = { class: "arbo-input__append" }, W = "^[0-9]*\\.?([0-9]+)?$", X = "^(-?)[0-9]*\\.?([0-9]+)?$", re = /* @__PURE__ */ K({
  __name: "Input",
  props: {
    ...P,
    ...A,
    useCustomDisplay: {
      type: Boolean,
      default: !1
    },
    isNumberType: {
      type: Boolean,
      default: !1
    },
    numberStep: {
      type: Number,
      default: 1
    }
  },
  emits: [
    "update:modelValue",
    "handleEnterKeyUp",
    "input:focus",
    "input:key-down",
    "input:blur",
    "input:change",
    "handleTab"
  ],
  setup(b, { expose: V, emit: y }) {
    const t = b, u = y, o = N(null), n = B({
      currentValue: "",
      isFocusing: !1
    });
    O((e) => {
      u("update:modelValue", e);
    }, 200), E(() => {
      n.currentValue = t.modelValue;
    }), i(
      () => n.currentValue,
      (e) => {
        t.modelValue !== e && u("update:modelValue", e);
      }
    ), i(
      () => t.modelValue,
      (e) => {
        n.currentValue !== e && (n.currentValue = e);
      }
    ), i(
      () => t.value,
      (e) => {
        n.currentValue !== e && (n.currentValue = e);
      }
    );
    const h = (e) => {
      n.currentValue = e.target.value, u("input:change", n.currentValue);
    }, _ = (e) => {
      u("handleEnterKeyUp", e);
    }, g = (e) => {
      u("handleTab", e);
    }, w = (e) => {
      u("input:key-down", e);
      const r = e.key;
      if (t.isNumberType) {
        if (e.key === "ArrowUp" ? (e.preventDefault(), n.currentValue = (parseFloat(n.currentValue) || 0) + 1) : e.key === "ArrowDown" && (e.preventDefault(), n.currentValue = (parseFloat(n.currentValue) || 0) - 1), r === "-" && n.currentValue.toString() === "")
          return;
        (!/^[0-9.]$/.test(r) || r === "." && n.currentValue.toString().includes(".")) && e.preventDefault();
      }
      if (t.regex && !k(n.currentValue + r)) {
        e.preventDefault();
        return;
      }
    }, k = (e) => {
      let r = t.regex;
      return !r && t.type === "number" && (t.min >= 0 ? r = W : r = X), new RegExp(r).test(e);
    };
    function v() {
      f(() => {
        o.value.focus();
      });
    }
    function x() {
      f(() => {
        o.value.blur();
      });
    }
    const D = (e) => {
      n.isFocusing = !0, u("input:focus", e);
    }, C = (e) => {
      n.isFocusing = !1, u("input:blur", e);
    };
    return V({
      focusInput: v,
      blurInput: x,
      getCurrentValue: () => n.currentValue
    }), (e, r) => {
      const s = I("auto-focus");
      return c(), p("div", j, [
        t.label ? (c(), p("div", q, [
          l(e.$slots, "label", {
            label: t.label
          }, () => [
            a("div", G, S(t.label), 1)
          ])
        ])) : $("", !0),
        a("div", {
          class: d(["arbo-input__form", [t.size.toLowerCase(), { border: t.hasBorder }, t.isDark ? "dark" : "light", { disable: t.disable }, { focusing: n.isFocusing }]])
        }, [
          a("div", H, [
            l(e.$slots, "prepend")
          ]),
          l(e.$slots, "default", {}, () => [
            T(L, {
              title: n.currentValue
            }, {
              default: U(() => [
                M(a("input", {
                  class: d(["arbo-input__input-form w-full", [{ border: t.hasBorder }, t.isDark ? "dark" : "light", { disable: t.disable }]]),
                  "onUpdate:modelValue": r[0] || (r[0] = (F) => n.currentValue = F),
                  min: t.min,
                  max: t.max,
                  placeholder: t.placeholder,
                  disabled: t.disable,
                  type: t.type,
                  ref_key: "inputElement",
                  ref: o,
                  onInput: h,
                  onKeydown: w,
                  onKeyup: [
                    m(_, ["enter"]),
                    m(g, ["tab"])
                  ],
                  pattern: t.regex,
                  onFocus: D,
                  onBlur: C
                }, null, 42, J), [
                  [R, n.currentValue],
                  [s, t.autoFocus],
                  [z, !t.useCustomDisplay]
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            l(e.$slots, "display", {
              value: n.currentValue
            })
          ]),
          a("div", Q, [
            l(e.$slots, "append")
          ])
        ], 2)
      ]);
    };
  }
});
export {
  re as _
};
